import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import CharityIssueCategoryService from "../../../../services/CharityIssueCategoryService";

const api = new CharityIssueCategoryService();
export type State = {
  errors?: {
    name?: string[];    
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;    
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),  
});

export async function addCategory(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
  };
  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Charity Issue Category.",
      };
    }
    const { name} = validatedFields.data;

    const result = await api.createCharityIssueCategory({ name });
    if (result.status == 201)
      return {
        message: "Charity Issue Category created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create charity issue category.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create charity issue category.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateCategory(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update Charity Issue Category.",
      };
    }
    const { name } = validatedFields.data;

    const result = await api.updateCharityIssueCategory({ id, name });
    if (result.status == 204)
      return {
        message: "Charity Issue Category updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update charity issue category.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update charity issue category.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteCategory(id: number, prevState: State) {
  try {
    await api.deleteCharityIssueCategory(id);
    return {
      message: "Charity issue category deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete charity issue category.",
      success: false,
    };
  }
}
